<template>
  <div>
    <nav
      class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
      id="navbarBlur"
      navbar-scroll="true"
    >
      <div class="container-fluid py-1 px-3">
        <nav aria-label="breadcrumb">
          <ol
            class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5"
          >
            <li
              class="nav-item d-xl-none ps-0 ms-0 me-3 d-flex align-items-center"
              v-show="!mobileMenuOpen"
            >
              <button
                class="navbar-toggler shadow-none ms-2"
                type="button"
                @click="openMobileMenu"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon mt-2">
                  <span class="navbar-toggler-bar bar1"></span>
                  <span class="navbar-toggler-bar bar2"></span>
                  <span class="navbar-toggler-bar bar3"></span>
                </span>
              </button>
            </li>
            <!-- <li class="breadcrumb-item text-sm d-flex align-items-center d-none d-md-block d-lg-block">
              <a class="opacity-5 text-dark" href="javascript:;" @click="goToRoute('/admin/overview')">Inicio</a>
            </li> -->
          </ol>
        </nav>
        <div
          class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4"
          id="navbar"
        >
          <div class="ms-md-auto pe-md-3 d-flex align-items-center"></div>
          <ul class="navbar-nav justify-content-end">
            <li class="nav-item d-flex align-items-center justify-content-end me-4">
              <!-- Avatar -->
              <img
                v-if="user.url_image"
                :src="user.url_image"
                class="rounded-circle shadow-4-strong avatar-sm me-3 mb-0 img-fluid d-none d-md-block d-lg-block"
                alt="Image"
                style="
                  height: 60px !important;
                  width: 60px !important;
                  object-fit: cover;
                "
              />
              <img
                v-else
                src="../../public/favicon/fvf_logo_icon.png"
                class="rounded-circle shadow-4-strong avatar-sm me-3 mb-0 img-fluid d-none d-md-block d-lg-block"
                alt="Image"
                style="height: 60px !important; width: 60px !important"
              />
              
              <!-- User Details -->
              <div class="d-flex flex-column align-items-start d-none d-md-flex d-lg-flex" style="max-width: 250px;">
                <span
                  v-if="name"
                  class="text-dark font-weight-bold text-start"
                  style="text-transform: capitalize !important; font-size: 0.95rem; line-height: 1.2;"
                >
                  {{ name }}
                </span>
                <span
                  v-else
                  class="text-dark font-weight-bold text-start"
                  style="text-transform: capitalize !important; font-size: 0.95rem; line-height: 1.2;"
                >
                  No especificado
                </span>
              
                <span
                  v-if="user && user.is_rne == 1"
                  class="badge bg-success text-white"
                  style="font-size: 0.7rem; border-radius: 10px; padding: 4px 8px; margin-top: 4px; cursor: pointer;"
                  @click="goToRoute('/rne')"
                >
                  Usuario asociado a RNE
                </span>
                <span
                  v-else-if="user && user.is_rne != 1"
                  class="badge bg-warning text-white"
                  style="font-size: 0.7rem; border-radius: 10px; padding: 4px 8px; margin-top: 4px; background-color: #fb6340 !important; cursor: pointer;"
                  @click="goToRoute('/rne')"
                >
                  Usuario sin asociar a RNE
                </span>
              </div>
            </li>
            <li class="nav-item d-none d-xl-flex align-items-center">
              <!-- <a
                href="javascript:;"
                class="nav-link ms-2 text-body font-weight-bold px-0" style="text-transform: none !important"
              >
                <i class="fa fa-user me-sm-1"></i>
                <span class="d-sm-inline" style="color: rgb(53, 16, 32)" @click="closeSession"
                  > Cerrar sesión</span
                >
              </a> -->
              <a
                @click="closeSession"
                class="logout-icon-link"
                style="cursor: pointer"
                title="Cerrar sesión"
              >
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 17L21 12L16 7"
                    stroke="gray"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21 12H9"
                    stroke="gray"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 19C7.58172 19 4 15.4183 4 11C4 6.58172 7.58172 3 12 3C13.6569 3 15.1566 3.63214 16.2426 4.75736"
                    stroke="gray"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </li>
            <!-- <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
              <a
                href="javascript:;"
                class="nav-link text-body p-0"
                id="iconNavbarSidenav"
              >
                <div class="sidenav-toggler-inner">
                  <i class="sidenav-toggler-line"></i>
                  <i class="sidenav-toggler-line"></i>
                  <i class="sidenav-toggler-line"></i>
                </div>
              </a>
            </li> -->
          </ul>
        </div>
      </div>
    </nav>
    <div class="collapse navbar-collapse mobilemenu" id="navigation">
      <div class="d-xl-none sticky-top bg-white border-bottom">
        <div class="d-flex justify-content-between align-items-center p-3">
          <div class="d-flex align-items-center" style="min-width: 0">
            <div class="d-flex align-items-center">
              <img
                src="../../public/favicon/fvf_logo_icon.png"
                alt="FVF"
                class="me-2"
                style="width: 36px; height: 36px; object-fit: contain"
              />
              <img
                src="../../public/img/ccd_escudo.png"
                alt="CCD"
                class="me-3"
                style="width: 36px; height: 36px; object-fit: contain"
              />
            </div>
            <div class="d-flex flex-column" style="min-width: 0">
              <span class="fw-semibold text-dark" style="line-height: 1.1">FVF - CCD</span>
              <span class="text-muted" style="font-size: 0.85rem; line-height: 1.1">Menú</span>
            </div>
          </div>
          <button
            class="btn btn-sm btn-outline-secondary"
            type="button"
            @click="closeMobileMenu"
            aria-label="Close navigation"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
        <div class="px-3 pb-3">
          <div class="bg-light rounded-3 p-2">
            <div class="d-flex align-items-center">
              <img
                v-if="user.url_image"
                :src="user.url_image"
                class="rounded-circle me-2"
                alt="User"
                style="width: 40px; height: 40px; object-fit: cover"
              />
              <img
                v-else
                src="../../public/favicon/fvf_logo_icon.png"
                class="rounded-circle me-2"
                alt="User"
                style="width: 40px; height: 40px; object-fit: cover"
              />
              <div style="min-width: 0">
                <div class="fw-semibold text-dark text-truncate">{{ name || "No especificado" }}</div>
                <div class="text-muted text-truncate" style="font-size: 0.85rem">
                  {{ userTypeDisplay }}
                </div>
                <span
                  v-if="user && user.is_rne == 1"
                  class="badge bg-success text-white mt-1 d-inline-block"
                  style="font-size: 0.7rem; border-radius: 10px; padding: 2px 6px; cursor: pointer;"
                  @click="goToRoute('/rne')"
                >
                  Usuario asociado a RNE
                </span>
                <span
                  v-else-if="user && user.is_rne != 1"
                  class="badge bg-warning text-white mt-1 d-inline-block"
                  style="font-size: 0.7rem; border-radius: 10px; padding: 2px 6px; background-color: #fb6340 !important; cursor: pointer;"
                  @click="goToRoute('/rne')"
                >
                  Usuario sin asociar a RNE
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul class="navbar-nav mt-3 bg-white rounded-3 shadow-sm mx-3 mb-3 p-2">
        <li class="nav-item" @click="goToRoute('/overview')">
          <a
            class="nav-link"
            :class="{ active: $route.path.includes('/overview') }"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Inicio</span
            >
          </a>
        </li>
        <li class="nav-item mt-2" @click="goToRoute('/postulation')">
          <a
            class="nav-link"
            :class="{
              active:
                $route.path.includes('/postulation') ||
                $route.path == '/postulation',
            }"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Mis postulaciones</span
            >
          </a>
        </li>
        <li class="nav-item mt-2" @click="goToRoute('/my-payments')">
          <a
            class="nav-link"
            :class="{
              active:
                $route.path.includes('/my-payments') ||
                $route.path == '/my-payments',
            }"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Mis pagos</span
            >
          </a>
        </li>
        <li class="nav-item mt-2" @click="goToRoute('/profile')">
          <a
            class="nav-link"
            :class="{
              active:
                $route.path.includes('/profile') || $route.path == '/profile',
            }"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Mi perfil</span
            >
          </a>
        </li>
        <li v-if="isTrainerAndFormerPlayer || isTrainer" class="nav-item mt-2" @click="goToURL('https://www.conmebol.com/entrenadores-con-licencia-conmebol/')">
          <a
            class="nav-link"
            style="
              cursor: pointer;
              border-radius: 5%/50%;
              height: 30px;
            "
          >
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Conmebol</span
            >
          </a>
        </li>
        <li v-if="isTrainerAndFormerPlayer || isTrainer" class="nav-item mt-2" @click="goToURL('https://entrenadores.federacionvenezolanafutbol.com/iniciar_sesion')">
          <a
            class="nav-link"
            style="
              cursor: pointer;
              border-radius: 5%/50%;
              height: 30px;
            "
          >
            <span class="nav-link-text ms-3" style="text-transform: none"
              >RNE</span
            >
          </a>
        </li>
        <li class="nav-item mt-4 mb-3" @click="closeSession">
          <a
            class="nav-link text-danger"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <span class="nav-link-text ms-3" style="text-transform: none">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="display: inline-block; vertical-align: middle; margin-right: 8px;"
              >
                <path
                  d="M16 17L21 12L16 7"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M21 12H9"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 19C7.58172 19 4 15.4183 4 11C4 6.58172 7.58172 3 12 3C13.6569 3 15.1566 3.63214 16.2426 4.75736"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Cerrar sesión
            </span>
          </a>
        </li>
      </ul>
      <ul class="navbar-nav d-lg-block d-none"></ul>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import IconBox3D from "../components/Icons/Box3D";
import IconCreditCard from "../components/Icons/CreditCard";
import IconCustomerSupport from "../components/Icons/CustomerSupport";
import IconOffice from "../components/Icons/Office";
import IconShop from "../components/Icons/Shop";
import IconSpaceShip from "../components/Icons/SpaceShip";
import IconDocument from "../components/Icons/Document";
import Cookies from "js-cookie";

export default {
  components: {
    IconBox3D,
    IconCreditCard,
    IconOffice,
    IconShop,
    IconSpaceShip,
    IconDocument,
    IconCustomerSupport,
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    getRole() {
      if (this.role == 1) {
        return "Administrador";
      } else if (this.role == 2) {
        return "Asesor";
      } else {
        return "Usuario";
      }
    },
    isAdmin() {
      return this.role == 1 ? true : false;
    },
    isAdvisor() {
      return this.role == 2 ? true : false;
    },
    isTrainer() {
      return this.id_type_user == 1;
    },
    isFormerPlayer() {
      return this.id_type_user == 2;
    },
    isTrainerAndFormerPlayer() {
      return this.id_type_user == 3;
    },
    isUser() {
      return this.role == undefined ? true : false;
    },
    userTypeDisplay() {
      // Si no hay user o type_user, retornar "Usuario" por defecto
      if (!this.user || !this.user.type_user || !this.user.type_user.name) {
        return "Usuario";
      }

      // Si id_type_user es 1 (Entrenador) pero is_rne no es 1, mostrar "Usuario"
      if (this.user.id_type_user == 1 && this.user.is_rne != 1) {
        return "Usuario";
      }

      // Para cualquier otro caso, mostrar el nombre del tipo de usuario
      return this.user.type_user.name;
    },
  },
  data() {
    return {
      id_type_user: Cookies.get("id_type_user"),
      role: Cookies.get("role"),
      username: Cookies.get("id"),
      name: "",
      activeNotifications: false,
      user: "",
      mobileMenuOpen: false,
    };
  },
  mounted() {
    this.loadProfile();
  },
  methods: {
    ...mapActions(["logout", "load_User", "load_Admin"]),
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    closeSession() {
      console.log("Bye Bye");
      this.logout();
      location.reload();
    },
    loadProfile() {
      if (this.isUser) {
        this.load_User(this.username)
          .then((response) => {
            if (response.code === 200) {
              this.user = response.data;
              this.name = this.user.first_name + " " + this.user.last_name;
              this.loaded = true;
            }
          })
          .catch((error) => {});
      } else {
        this.load_Admin(this.username)
          .then((response) => {
            if (response.code === 200) {
              this.user = response.data;
              this.name = this.user.first_name + " " + this.user.last_name;
              this.loaded = true;
            }
          })
          .catch((error) => {});
      }
    },
    goToURL(url) {
      window.open(url, "_blank");
    },
    goToRoute(route) {
      this.$router.push(route);
      this.closeMobileMenu();
    },
    openMobileMenu() {
      const menu = document.getElementById("navigation");
      if (menu) {
        menu.classList.add("show");
        this.mobileMenuOpen = true;
      }
    },
    closeMobileMenu() {
      const menu = document.getElementById("navigation");
      if (menu && menu.classList.contains("show")) {
        menu.classList.remove("show");
        this.mobileMenuOpen = false;
        
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) {
          backdrop.remove();
        }
        
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }
    },
  },
};
</script>
<style>
@media (min-width: 1200px) {
  .mobilemenu {
    display: none !important;
  }
}
#navigation {
  z-index: 5;
}

.bg-gray-100 {
  background-color: white !important;
}

.home-bg {
  background-color: #f8f9fa !important;
}

.logout-icon-link svg path {
  transition: stroke 0.2s;
}
.logout-icon-link:hover svg path {
  stroke: rgb(53, 16, 32);
}

/* Menú móvil a pantalla completa cuando está abierto */
@media (max-width: 1199px) {
  #navigation.show {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    max-width: 100vw;
    height: 100vh;
    background: #f8f9fa;
    z-index: 1050;
    overflow-x: hidden;
    overflow-y: hidden;
  }
}
</style>
